import React from 'react'
import { sizes } from '~/constants/mediaQuery'

import { UncontrolledTooltip } from 'reactstrap'
import { SHORT_ID_LENGTH } from '~/constants/byoGG'
import createLinks from '~/helpers/createLinks'
import { ReactComponent as AttachmentIcon } from '../../../../../../assets/img/svg/attachment.svg'
import { ReactComponent as GoogleBusinessProfile } from '../../../../../../assets/img/svg/google-business.svg'
import { ReactComponent as QRCodeIcon } from '../../../../../../assets/img/svg/qrcode.svg'
import { ReactComponent as WhatsappIcon } from '../../../../../../assets/img/svg/whatsapp.svg'
import { toast } from 'react-toastify'
import { CheckCircle } from 'react-feather'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'
import Styles from './styles'

const useListViewColumn = userIsClient => {
  const columns = React.useMemo(() => {
    const isMobile = window.innerWidth < +sizes.sm.replace('px', '')
    const BASE_COLUMNS = [
      {
        id: 'status',
        title: 'Status',
        centered: true,
        cell: item => (
          <Styles.LocationStatus
            className="locations-status"
            data-status={item.status}
          >
            <FormattedMessage id={_.lowerCase(item.status)} />
          </Styles.LocationStatus>
        ),
        sortable: true,
      },
      {
        id: 'code',
        title: 'Code',
        cell: item => <Styles.LocationCode>{item?.code}</Styles.LocationCode>,
        sortable: true,
      },
      {
        id: 'name',
        title: 'Name',
        cell: item => (
          <Styles.LocationAddress>
            <div>{item.name}</div>
            <div>
              <div>
                {(item.address || []).join(', ')}
                {item?.neighborhood && `, ${item.neighborhood}`}
              </div>
              <div>
                {item?.city} {item?.city && item?.state && '/'} {item?.state}
              </div>
            </div>
          </Styles.LocationAddress>
        ),
        width: '40%',
        sortable: true,
      },
      {
        id: 'profile',
        title: 'Profile',
        cell: item => {
          const byoGGURL = createLinks.byoGG(item)
          const whatsappURL = createLinks.whatsapp(item)

          return (
            <Styles.LocationProfile>
              {byoGGURL && (
                <>
                  <UncontrolledTooltip
                    placement="top"
                    target={`attachment-link-${item.id.slice(
                      -SHORT_ID_LENGTH
                    )}`}
                  >
                    <FormattedMessage id="Open Byo.gg profile" />
                  </UncontrolledTooltip>
                  <UncontrolledTooltip
                    placement="top"
                    target={`qrcode-link-${item.id.slice(-SHORT_ID_LENGTH)}`}
                  >
                    <FormattedMessage id="Open review QR Code" />
                  </UncontrolledTooltip>
                </>
              )}
              <UncontrolledTooltip
                placement="top"
                target={`google-link-${item.id.slice(-SHORT_ID_LENGTH)}`}
              >
                <FormattedMessage id="Google Business profile review URL" />
              </UncontrolledTooltip>
              {whatsappURL && (
                <UncontrolledTooltip
                  placement="top"
                  target={`whatsapp-link-${item.id.slice(-SHORT_ID_LENGTH)}`}
                >
                  <FormattedMessage id="Copy Whatsapp URL" />
                </UncontrolledTooltip>
              )}

              {byoGGURL && (
                <a
                  id={`attachment-link-${item.id.slice(-SHORT_ID_LENGTH)}`}
                  href={byoGGURL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AttachmentIcon width="20" />
                </a>
              )}
              <a
                id={`google-link-${item.id.slice(-SHORT_ID_LENGTH)}`}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <GoogleBusinessProfile width="18" />
              </a>
              {byoGGURL && (
                <a
                  id={`qrcode-link-${item.id.slice(-SHORT_ID_LENGTH)}`}
                  href={`${byoGGURL}/review-google`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <QRCodeIcon width="20" />
                </a>
              )}
              {whatsappURL && (
                <button
                  id={`whatsapp-link-${item.id.slice(-SHORT_ID_LENGTH)}`}
                  onClick={() => {
                    navigator.clipboard.writeText(whatsappURL)
                    toast.success(<FormattedMessage id="Copied to clipboard" />)
                  }}
                >
                  <WhatsappIcon width="20" />
                </button>
              )}
            </Styles.LocationProfile>
          )
        },
      },
      {
        id: 'score',
        title: 'Score',
        centered: true,
        cell: item => {
          const score = item?.score || 0
          const color =
            item?.score >= 80
              ? '#48BB78'
              : item?.score >= 40
              ? '#F6AD55'
              : '#E53E3E'

          return (
            <>
              {score === 100 && (
                <Styles.FullScoreProgressBar>
                  <CheckCircle size="22" color="#48BB78" />
                </Styles.FullScoreProgressBar>
              )}
              {score !== 100 && (
                <Styles.ScoreProgressBar color={color} content={score || 0}>
                  <meter value={score || 0} min="0" max="100">
                    {score || 0}%
                  </meter>
                </Styles.ScoreProgressBar>
              )}
            </>
          )
        },
        sortable: true,
      },
    ]
    const EDIT_COLUMN = {
      id: 'action',
      title: 'Action',
      centered: true,
      cell: item => (
        <Styles.LocationEdit href={`/${item.id}/edit`}>
          <FormattedMessage id="Edit" />
        </Styles.LocationEdit>
      ),
    }

    const authorizedColumns = userIsClient
      ? BASE_COLUMNS
      : [...BASE_COLUMNS, EDIT_COLUMN]

    return authorizedColumns.filter(
      col => !isMobile || (col.id !== 'score' && col.id !== 'action')
    )
  }, [userIsClient])
  return {
    columns,
  }
}

export default useListViewColumn
